import { Injectable } from '@angular/core';
import { Address } from 'src/app/shared/models/address';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  formatAddressToString(address?: Address): string {
    if (address) {
      let output = `${address.road} ${address.number}`;
      if (address.letter) {
        output += `${address.letter}`;
      }
      if (address.floor) {
        output += ` ${address.floor}.`;
      }
      if (address.door) {
        output += ` ${address.door}.`;
      }

      output += `, ${address.postalCode} ${address.city}`;
      return output;
    }
    return '';
  }
}
